import { getProjectRouteLabel, titleCaseSegment } from "@repo/shared";

function joinPathWithQueryAndHash(url: URL): string {
  return `${url.pathname}${url.search}${url.hash}`;
}

export function toInternalAppPath(href: string): string | null {
  if (!href) return null;

  if (href.startsWith("/")) {
    return href;
  }

  try {
    const parsed = new URL(href);
    if (!parsed.pathname.startsWith("/project/")) return null;
    return joinPathWithQueryAndHash(parsed);
  } catch {
    return null;
  }
}

export function getInternalAppLinkLabel(pathOrHref: string): string | null {
  const normalizedPath = toInternalAppPath(pathOrHref) ?? pathOrHref;

  let parsedPath: string;
  try {
    parsedPath = normalizedPath.startsWith("/") ? normalizedPath : new URL(normalizedPath).pathname;
  } catch {
    return null;
  }

  const path = parsedPath.split("?")[0]?.split("#")[0] ?? parsedPath;
  const segments = path
    .split("/")
    .filter(Boolean)
    .map((segment) => decodeURIComponent(segment));

  if (segments[0] !== "project") return null;

  const projectSlug = segments[1];
  if (!projectSlug) return "Project";

  if (segments.length === 2) return `Project: ${titleCaseSegment(projectSlug)}`;

  const projectPath = `/${segments.slice(2).join("/")}`;
  return getProjectRouteLabel({
    path: projectPath,
  });
}
